import { useRef } from "react";
import { RevealWrapper, Container, Button, Image } from '@components';
import { getLinkData, getHighlightMarkup } from '@/core/utils';

import { useInView } from 'motion/react';
import { useViewSize } from '@/providers/ViewSizeContext';
// import { useClientMount } from '@/providers/ClientMountProvider';

import { AnimVals } from "@/utils/animUtils";
// import { useDebug } from "@/utils/useDebugLog";

// Styles
import styles from './AlbumDescBlock.module.scss';
import className from 'classnames/bind';
const cx = className.bind(styles);

interface AlbumDescBlockProps {
  artifactSingularHeadline: Array<{ line: string }>;
  artifactSingularBody: Array<{ text: string }>;
  image: any;
  cta?: any;
  className?: string;
}

export default function AlbumDescBlock(props: AlbumDescBlockProps) {
  // const { log } = useDebug({ name: 'AlbumDescBlock', bgColor: 'lime', enabled: true });

  const {
    artifactSingularHeadline,
    artifactSingularBody,
    image,
    cta,
    className,
  } = props;

  const ctaData = getLinkData(cta);

  const rootRef = useRef<HTMLDivElement>(null);

  const { isDesktop } = useViewSize();
  const REVEAL = AnimVals;
  const triggerPercent = isDesktop ? REVEAL.lg.triggerPercent : REVEAL.sm.triggerPercent;
  const isInView = useInView(rootRef, { amount: triggerPercent, once: REVEAL.once });

  // -------------------- Render

  return (
    <div className={cx(["album-desc-block", className])} ref={rootRef}>

      <RevealWrapper isInView={isInView}>
        <Container className={cx("content")}>

          <div className={cx("column-visual")}>
            <Image className={cx("image")} image={image} />
          </div>

          <div className={cx("column-copy")}>
            <div className={cx("title")}>
              <h2 className={cx("title-uc-xl", "title__lines")}>
                {artifactSingularHeadline.map((line, index) => (
                  <span
                    key={index}
                    className={cx(["line", `title__lines__line-${index}`])}
                    dangerouslySetInnerHTML={{ __html: getHighlightMarkup(line.line) }}
                  />
                ))}
              </h2>
            </div>

            <div className={cx("body")}>
              {artifactSingularBody.map((line, index) => (
                <div className={cx("body__p-container")} key={index}>
                  <p className={"text-m"}
                    dangerouslySetInnerHTML={{ __html: line.text }}
                  />
                  {index === artifactSingularBody.length - 1 && ctaData && (
                    <Button {...ctaData} />
                  )}
                </div>
              ))}
            </div>
          </div>

        </Container>
      </RevealWrapper>

    </div>
  );
}
